import * as React from "react"
import "./styles/story.css"

const StoryPage = () => {
    return (
        <main>

        </main>
    )
}

export default StoryPage